<template>
  <div class="lastnews-container">
    <h2>最新动态</h2>
    <div v-if="list.length">
      <div class="lastnews-list">
        <template v-for="(item, index) in list">
          <list-item :key="index" :info="item"></list-item>
        </template>
      </div>
      <!-- 分页 -->
      <pagination v-show="total>0" :total="total" :page.sync="pageParams.pageNumber" :pageSizes="[8, 10, 20, 30]" :limit.sync="pageParams.pageSize" @pagination="getPageData" />
    </div>
    <div class="none-result" v-else>
      暂无最新动态信息
    </div>
  </div>
</template>

<script>
import { contentFinds } from "@/api/common/content";
import ListItem from "./components/listItem";

export default {
  data() {
    return {
      list: [],
      total: 0,
      queryBean: {
        contentBean: {
          type1: "最新动态",
        },
      },
      pageParams: {
        pageNumber: 1,
        pageSize: 8,
        sort: "priority, publish_time",
        order: "desc"
      },
    }
  },
  props: {

  },
  components: {
    ListItem
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getData(params) {
      let data = Object.assign({}, this.pageParams, this.queryBean, params || {});
      return new Promise(async (resolve, reject) => {
        const res = await contentFinds(data);
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    },
    getPageData() {
      this.getData().then(res => {
        this.list = res.list;
        this.total = res.total;
      })
    }
  },
}
</script>

<style lang="less" scoped>
.lastnews-container {
  width: 100%;
  h2 {
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    color: #212529;
    margin-bottom: 30px;
  }

  .lastnews-list {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    gap: 30px;
  }

  .none-result {
    text-align: center;
    font-size: 16px;
    color: #999;
    line-height: 60px;
    margin: 30px;
  }
}

@media screen and (max-width: 768px) {
  .lastnews-container {
    .lastnews-list {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      gap: 14px;
    }
  }
}
</style>